import shiftApi from '../../api/shift'
import { extendMoment } from 'moment-range'
import moment from 'moment'
const extendedMoment = extendMoment(moment)

// initial state
const state = {
  selectedTimeFrame: 'Month',
  selectedShiftFilter: null,
  viewableTimePeriods: ['Week', 'Month'],
  concernedDate: Date.now(), // either today, or a date IN the set of selected week or selected month. basically, the start and end dates should slide themselves around 'concernedDate' based on if we're viewing weeks or months.
  hasNavigated: false,
  today: Date.now(),
  lastViewedStart: '',
}

// getters
const getters = {
  firstDayOfMonthBlock (state, getters) {
    const firstDayOfThisMonth = moment(state.concernedDate).clone().startOf('month');
    const firstDayOfBlockMonth = firstDayOfThisMonth.clone().startOf('week'); // first day of displayed month
    return firstDayOfBlockMonth
  },

  lastDayOfMonthBlock (state, getters) {
    const lastDayOfMonthBlock = getters.firstDayOfMonthBlock.clone().add(34, 'days')
    return lastDayOfMonthBlock
  },

  displayStartDate (state, getters) {
    if (state.selectedTimeFrame == 'Week') {
      var sunday = moment(state.concernedDate).day("Sunday")
      return sunday
    } else {
      return moment(getters.firstDayOfMonthBlock)
    }
  },

  displayEndDate (state, getters) {
    if (state.selectedTimeFrame == 'Week') {
      var saturday = moment(state.concernedDate).day("Saturday")
      return saturday
    } else {
      return moment(getters.lastDayOfMonthBlock)
    }
  },

  daysToRender (state, getters) {
    // make an array of days (maybe moment objects?)
    // from displayStartDate to displayEndDate, inclusive
    return Array.from(
      moment.range(
        moment(getters.displayStartDate),
        moment(getters.displayEndDate)
      ).by('days')
    )
  },

  //myShiftsInTimePeriod (state, getters, rootState) {
    //var shifts = getters.daysToRender.flatMap(day => {
      //return rootState.shifts.owned.filter(shift => {
        //return moment(shift.startDatetime).isSame(day, 'day')
      //})
    //})
    //return shifts
  //},

  //availableShiftsInTimePeriod (state, getters, rootState) {
    //var shifts = getters.daysToRender.flatMap(day => {
      //return rootState.shifts.available.filter(shift => {
        //return moment(shift.startDatetime).isSame(day, 'day')
      //})
    //})
    //return shifts
  //},
}

// actions
const actions = {
  lastViewedStart ({ commit, state }, start) {
    commit('setLastViewedStart', start)
  },

  goBackWeek ({ dispatch, state }) {
    var oldDate = state.concernedDate
    var sunday = moment(oldDate).day("Sunday")
    var prevSunday = moment(oldDate).day(-7)
    dispatch('changeConcernedDate', prevSunday)
    dispatch('setHasNavigated', prevSunday)
  },

  goBackMonth ({ dispatch, state }) {
    var oldDate = state.concernedDate
    var prevMonth = moment(oldDate).clone().subtract(1, 'month')
    dispatch('changeConcernedDate', prevMonth)
  },

  goForwardWeek ({ dispatch, state }) {
    var oldDate = state.concernedDate
    var sunday = moment(oldDate).day("Sunday")
    var nextSunday = moment(oldDate).day(7)
    dispatch('changeConcernedDate', nextSunday)
  },

  goForwardMonth ({ dispatch, state }) {
    var oldDate = state.concernedDate
    var nextMonth = moment(oldDate).clone().add(1, 'month')
    dispatch('changeConcernedDate', nextMonth)
  },

  changeConcernedDate ({ commit, getters, dispatch }, newDate) {
    dispatch('setHasNavigated')
    commit('changeConcernedDate', newDate)
    dispatch('getShiftsInRange')
  },

  getShiftsInDates ({ getters, dispatch}, params) {
    console.log('getShiftsInDates userId: ', params.userId)
    shiftApi.getFromTo(
      params,
      shifts => {
        dispatch('shifts/setShifts', shifts, { root: true })
    })
  },

  getShiftsInRange ({ getters, dispatch }) {
    const userId = 4
    const params = {
      userId: userId,
      start: getters.displayStartDate.valueOf(),
      end: getters.displayEndDate.valueOf(),
    }
    shiftApi.getFromTo(
      params,
      shifts => {
        dispatch('shifts/setShifts', shifts, { root: true })
    })
  },

  goToToday ({ dispatch, state }) {
    var today = Date.now()
    dispatch('changeConcernedDate', today)
  },

  getIndex ({ dispatch }) {
    if (state.hasNavigated) {
      dispatch('changeConcernedDate', state.concernedDate)
    } else {
      dispatch('goToToday')
    }
  },

  setHasNavigated ({ commit }) {
    commit('setHasNavigated')
  },

  setSelectedTimeFrame ({ commit, dispatch }, timeFrame) {
    commit('setSelectedTimeFrame', timeFrame)
    dispatch('getShiftsInRange')
  },

  setSelectedShiftFilter ({ commit, dispatch }, filter) {
    commit('setSelectedShiftFilter', filter)
    // dispatch('getShiftsInRange')
  },
}

// mutations
const mutations = {
  // updateField,
  setSelectedTimeFrame (state, newTimeFrame) {
    state.selectedTimeFrame = newTimeFrame
  },

  setSelectedShiftFilter (state, newFilter) {
    state.selectedShiftFilter = newFilter
  },

  changeConcernedDate (state, newDate) {
    state.concernedDate = newDate
  },

  setHasNavigated (state) {
    state.hasNavigated = true
  },

  setLastViewedStart (state, start) {
    state.lastViewedStart = start
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
